module.exports = JSON.parse('{"theme.docs.paginator.previous":"Previous","theme.docs.paginator.next":"Next up"}')